import { ConfigOptions, MainMenu, Widget } from 'rangeConfig/@types';
import ChangeFramesColor from 'components/ProductSidebar/menus/Widgets/ChangeColor/ChangeFrameColor';
import {
  SolutionDepthToggle,
  SolutionHeightToggle
} from 'rangeConfig/pax/widgets/changeSize/ChangeSolutionSize';
import checkWidget from 'rangeConfig/shared/widgets/checkWidget';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import framesProductListConfig from './productListConfig';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import hideDoors from 'rangeConfig/shared/behaviors/hideDoors';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import platform from 'rangeConfig/shared/utils/platform';
import {
  hideDepthToggle,
  hideHeightToggle,
  hideNoFramesForSelection
} from 'rangeConfig/pax/rules/hideMenuRules';
import LinkToAutofill from 'rangeConfig/pax/features/AutofillPax/widgets/LinkToAutofill';
import openAutofillSheet from 'rangeConfig/pax/features/AutofillPax/behaviors/openAutofillSheet';
import { isMobile } from 'utils/platform';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import ErrorMessageInline from 'rangeConfig/shared/widgets/ErrorMessageInline';
import withErrorMessage from 'rangeConfig/shared/widgets/withErrorMessage';
import { getNoFramesForColorDepthCombination } from 'rangeConfig/shared/utils/errorMessages';

const widgets = (options?: ConfigOptions) => {
  const widgets = {
    desktop: [
      {
        id: 'change-frame-color',
        component: ChangeFramesColor
      },
      {
        id: 'change-solution-size-depth',
        component: checkWidget(SolutionDepthToggle),
        title: 'storageone.depth',
        hidden: hideDepthToggle
      },
      {
        id: 'change-solution-size-height',
        component: checkWidget(SolutionHeightToggle),
        title: 'storageone.height',
        hidden: hideHeightToggle
      },
      {
        id: 'pax-link-to-autofill',
        component: LinkToAutofill,
        hidden: () => !options?.featureFlags?.paxAutofill
      },
      {
        id: 'frames-product-list',
        component: withProducts(ProductList, framesProductListConfig())
      } as Widget,
      {
        id: 'error-message-no-frames-for-color-depth-combination',
        component: withErrorMessage(getNoFramesForColorDepthCombination)(ErrorMessageInline),
        hidden: () => hideNoFramesForSelection()
      }
    ],
    mobile: [
      {
        id: 'change-frame-color',
        component: ChangeFramesColor,
        title: 'storageone.colorFilterLabel'
      },
      {
        id: 'change-solution-size-depth',
        component: checkWidget(SolutionDepthToggle),
        title: 'storageone.depth'
      },
      {
        id: 'change-solution-size-height',
        component: checkWidget(SolutionHeightToggle),
        title: 'storageone.height'
      },
      {
        id: 'frames-product-list',
        component: withProducts(ProductSwiper, framesProductListConfig()),
        title: 'storageone.newMenuSubmenuHeading'
      }
    ]
  };

  return widgets;
};

const mainMenu = (options?: ConfigOptions): MainMenu => {
  return {
    menuTitle: 'storageone.productListFramesTitle',
    behaviors: {
      productGroupEntered:
        isMobile() && options?.featureFlags?.paxAutofillMobile
          ? [hideDoors, openAutofillSheet]
          : [hideDoors],
      productGroupExited: [showDoors]
    },
    widgets: widgets(options)[platform]
  };
};

export default mainMenu;
